import React from 'react';
import { StyledTab, StyledTabs } from './StyledTabs';
import TabLabel from './components/TabLabel';

export interface ITab {
  id: string;
  label: string;
  onClick?: () => void;
}

interface IProps {
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
}

const Tabs: React.FC<IProps> = (props) => {
  const { activeTab, setActiveTab } = props;

  const tabs: ITab[] = [
    {
      id: '/',
      label: 'Teams and settings',
      // onClick: (): void => uiStore.setActiveTab(TabsNames.BallTracking),
    },
    {
      id: 'accepted',
      label: 'Features',
      // onClick: (): void => uiStore.setActiveTab(TabsNames.PlayerTracking),
    },
  ];

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number): void => {
    setActiveTab(newValue);
  };

  return (
    <StyledTabs value={activeTab} onChange={handleChange} indicatorColor='secondary'>
      {tabs.map((tab: ITab) => {
        return <StyledTab key={tab.id} label={<TabLabel label={tab.label} />} onClick={tab.onClick} />;
      })}
    </StyledTabs>
  );
};

export default Tabs;
